(function($, angular, window) {
    'use strict';

    /**
     * Please NOTE: This directive is used to get equal height rows for the compare table that is based on
     * columns and the rows are not in a format that can be easily auto height-resize using css.
     */
    window.THF.Angular.LiveQuoteTool.directive('equalHeightRows', ['$timeout', function( $timeout ) {
        var calculated = false;

        var link = function (scope, elem, attrs) {

            var allRowClassName = '.'+attrs.equalHeightRows;

            scope.columnHeights = {};
            scope.columnHeightValues = {};

            function resizeRows($elems) {
                $elems.each(function() {
                    var id = $(this).attr('data-equal-height-row-id');
                    var prevHeight;

                    if( typeof scope.columnHeightValues[id] !== 'undefined' ) {
                        prevHeight = scope.columnHeightValues[id];
                        $(this).css('height', '');
                    }

                    if( typeof scope.columnHeights[id] === 'undefined' ) {
                        scope.columnHeights[id] = 0;
                    }

                    scope.columnHeights[id] = ((scope.columnHeights[id] < $(this).outerHeight()) ? $(this).outerHeight() : scope.columnHeights[id]);
                    $(this).css('height', prevHeight);
                });

                for (var k in scope.columnHeights ) { if( scope.columnHeights.hasOwnProperty(k) ) {
                    scope.columnHeightValues[k] = scope.columnHeights[k];
                }}
            }

            $(elem).css({visibility: 'hidden'});
            scope.$watchGroup([
                'panel',
                'products',
                'selectedProduct',
                'allProducts.slideWidth'
            ],function() { // Watch any changes to our element

                /**
                 * This is to ensure that the action only triggers after the item is no longer hidden.
                 */
                function performAction() {
                    var $container = $(elem);
                    if( !$container.parent().hasClass('ng-hide') ) {
                        var $allRows = $(allRowClassName, $container);
                        resizeRows($allRows);
                        $container.css({visibility: 'visible'});
                        console.log( 'Action Performed' );
                    }
                    else {
                        setTimeout(performAction, 100);
                    }
                }
                performAction();

            });
        };

        return {
            'restrict': 'A',
            'link': link
        };
    }]);
})(jQuery, angular, window);
